"use strict";

var React = require('react');

var RadioButtons = require('../radioButtons');

module.exports = function () {
  return /*#__PURE__*/React.createElement("div", {
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    className: this.props.getClassName('control-dock' + (this.props.disabled ? ' disabled' : ''))
  }, /*#__PURE__*/React.createElement(RadioButtons, {
    value: this.props.value,
    showRadioSymbol: false,
    orientation: "horizontal",
    onChange: this.props.onChange
  }, this.generateDockDirections()), /*#__PURE__*/React.createElement("div", {
    className: "grid horizontal"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid vertical"
  }));
};